import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppShell } from './components/AppShell';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { ResetPasswordPage } from './pages/ResetPassword';
import { ConfirmEmailPage } from './pages/ConfirmEmail';
import { ResendConfirmationPage } from './pages/ResendConfirmation';
import { SpotsPage } from './pages/SpotsPage';
import { CatchesPage } from './pages/CatchesPage';
import { LogCatchPage } from './pages/LogCatchPage';
import { ClubsPage } from './pages/ClubsPage';
import { ClubDetailPage } from './pages/ClubDetailPage';
import { SessionsPage } from './pages/SessionsPage';
import { NewSessionPage } from './pages/NewSessionPage';
import { SessionDetailPage } from './pages/SessionDetailPage';
import { AdminPage } from './pages/AdminPage';
import { CatchDetailPage } from './pages/CatchDetailPage';

export function App() {
  return (
    <ThemeProvider>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/confirm-email" element={<ConfirmEmailPage />} />
            <Route path="/resend-confirmation" element={<ResendConfirmationPage />} />
            <Route element={<ProtectedRoute allowGuest><AppShell /></ProtectedRoute>}>
              <Route path="/spots" element={<ErrorBoundary><SpotsPage /></ErrorBoundary>} />
              <Route path="/spots/:spotId" element={<ErrorBoundary><SpotsPage /></ErrorBoundary>} />
              <Route path="/catches/:id" element={<ErrorBoundary><CatchDetailPage /></ErrorBoundary>} />
            </Route>
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/spots" replace />} />
              <Route path="/catches" element={<ErrorBoundary><CatchesPage /></ErrorBoundary>} />
              <Route path="/catches/log" element={<ErrorBoundary><LogCatchPage /></ErrorBoundary>} />
              <Route path="/clubs" element={<ErrorBoundary><ClubsPage /></ErrorBoundary>} />
              <Route path="/clubs/:id" element={<ErrorBoundary><ClubDetailPage /></ErrorBoundary>} />
              <Route path="/sessions" element={<ErrorBoundary><SessionsPage /></ErrorBoundary>} />
              <Route path="/sessions/new" element={<ErrorBoundary><NewSessionPage /></ErrorBoundary>} />
              <Route path="/sessions/:id" element={<ErrorBoundary><SessionDetailPage /></ErrorBoundary>} />
              <Route path="/admin" element={<ErrorBoundary><AdminPage /></ErrorBoundary>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
    </ThemeProvider>
  );
}
